import React from "react"
import ReactDOM from "react-dom"
import { BrowserRouter } from "react-router-dom"
import "./index.css"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import "antd/dist/antd.css"
import MaintenanceGuard from "./components/maintenance_guard"

import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

const queryClient = new QueryClient()

ReactDOM.render(
  <BrowserRouter>
    <MaintenanceGuard>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </MaintenanceGuard>
  </BrowserRouter>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
